export const selectViewFunction = function (data, selectionRules) {
  for (let item of selectionRules) {
    for (let rule of item) {
      if (!Array.isArray(rule)) {
        return rule;
      } else if (!(rule[0] in data) || (data[rule[0]] !== rule[1])) {
        break;
      }
    }
  }
};

export const createRandomArray = function (length) {
  let numbersArray = [];
  for (let i = 1; i <= length; i++) {
    numbersArray.push(i);
  }

  let currentIndex = length;

  while (0 !== currentIndex) {
    let randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    let temporaryValue = numbersArray[currentIndex];
    numbersArray[currentIndex] = numbersArray[randomIndex];
    numbersArray[randomIndex] = temporaryValue;
  }

  return numbersArray;
}

export const createOrder = function (mockObject, questionsNumber, orderArray) {
  const last = orderArray[questionsNumber - 1];

  orderArray.forEach((elem, i) => {

    for (let key in mockObject) {

      if (mockObject[key].next === 'win') {
        if (parseInt(key) === elem && i < questionsNumber && parseInt(key) !== last)  {
          mockObject[key].next = String(orderArray[i + 1]);
        }

        if (parseInt(key) === last) {
          mockObject[key].next = 'finish';
        }
      }
    }
  })
}



// WEBPACK FOOTER //
// ./moduls/utils.js